import { inject } from '@angular/core';
import { CanDeactivateFn, Router, UrlTree } from '@angular/router';
import { ResetPasswordConfirmComponent } from '@domains/auth/components/reset-password-confirm/reset-password-confirm.component';

/**
 * Guard to prevent navigation back from reset-password page
 *
 * When user arrives at reset-password page from email link,
 * browser history is empty. If user presses back button,
 * it causes blank page with module loading errors.
 *
 * This guard intercepts the back navigation and redirects
 * to login page instead.
 */
export const resetPasswordDeactivateGuard: CanDeactivateFn<ResetPasswordConfirmComponent> = (
  component,
  currentRoute,
  currentState,
  nextState
): boolean | UrlTree => {
  const router = inject(Router);

  // If user completed the reset successfully, allow navigation
  if (component.isSuccess()) {
    return true;
  }

  // If user is navigating back (no nextState or going to previous URL)
  // redirect to login instead
  if (!nextState || nextState.url === '') {
    return router.createUrlTree(['/auth/login']);
  }

  // Allow all other navigation
  return true;
};
